import Alpine from 'alpinejs'

/** @type {import('gsap').default} */
let gsap = null
/** @type {import('gsap/ScrollTrigger').default} */
let ScrollTrigger = null

export default (function () {
  Alpine.data('containerAnimation', function () {
    let neededModules = null
    /** @type {[gsap.core.Tween]} */
    let timelines = []
    let observers = []
    const load = async () => {
      if (!gsap) {
        neededModules = await Promise.all([
          import('gsap').then((mod) => mod.default),
          import('gsap/ScrollTrigger').then((mod) => mod.default),
        ])
        ;[gsap, ScrollTrigger] = neededModules
        gsap.registerPlugin(ScrollTrigger)
      }
    }

    return {
      async horizontalTween({ offsetRight = 0, start = 'top center', end = 'top 33%', scrub = 2 } = {}) {
        await load()

        /** @type {gsap.core.Tween} */
        let timeline = null
        const itemsContainer = this.$root
        const items = [...itemsContainer.children]
        
        if (!items.length) return

        const run = () => {
          if (timeline) {
            timeline.progress(0)
            timeline.kill()
            timeline = null
          }

          // Helper to compute horizontal overflow (accounts for gaps/margins via scrollWidth)
          const computeMoveDistance = () => {
            const contentWidth = itemsContainer.scrollWidth
            const containerInnerWidth = itemsContainer.clientWidth
            return Math.max(0, contentWidth - containerInnerWidth + offsetRight)
          }

          const moveDistance = computeMoveDistance()

          // Only animate if there's overflow
          if (moveDistance <= 0) {
            gsap.set(items, { clearProps: 'x' })
            return
          }

          timeline = gsap.to(items, {
            x: () => -computeMoveDistance(),
            ease: 'none',
            scrollTrigger: {
              trigger: itemsContainer,
              start,
              end,
              scrub,
              invalidateOnRefresh: true,
            },
          })

          timelines.push(timeline)
        }

        // Kick off once
        requestAnimationFrame(() => {
          run()
          ScrollTrigger && ScrollTrigger.refresh()
        })

        // Recompute on resize
        const ro = new ResizeObserver(() => {
          requestAnimationFrame(() => {
            run()
            ScrollTrigger && ScrollTrigger.refresh()
          })
        })
        ro.observe(itemsContainer)

        observers.push(ro)
      },

      destroy() {
        timelines.forEach(timeline => timeline.kill())
        timelines = []  
        observers.forEach(observer => observer.disconnect())
        observers = []
      },
    }
  })
})()
